import React from "react";
import { Sparkles } from "lucide-react";

export function Footer({ t }) {
  return (
    <footer className="py-12 border-t border-[#EAE5DB] bg-[#FAF6F0]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-[#D95D39] flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-white" strokeWidth={2.5} />
          </div>
          <div>
            <div className="font-heading font-bold text-[#292524]">AussieCV</div>
            <div className="text-xs text-[#78716C]">{t.footer.tagline}</div>
          </div>
        </div>
        <div className="text-xs text-[#78716C]">{t.footer.legal}</div>
      </div>
    </footer>
  );
}
